import type { DestinationMetadata } from '@/scopes/search/quick-search/domain/types'
import type { FilterOption } from '@/scopes/search/types'
import Diacritics from 'diacritic'

const normalize = (str: string) => Diacritics.clean(str || '').toLowerCase().trim()

export function getFilteredOptions(options: FilterOption<string, DestinationMetadata>[], query: string) {
  const normalizedQuery = normalize(query)

  if (!normalizedQuery)
    return options

  const searchTerms = normalizedQuery.split(/\s+/).filter(Boolean)

  const mappedOptions = options.map(option => ({
    original: option,
    normName: normalize(option.name),
    normParent: normalize(option.metadata?.parentName ?? ''),
  }))

  const filtered = mappedOptions.filter(({ normName, normParent }) => {
    return searchTerms.every(term =>
      normName.includes(term) || normParent.includes(term),
    )
  })

  filtered.sort((a, b) => {
    if (a.normName === normalizedQuery)
      return -1
    if (b.normName === normalizedQuery)
      return 1

    const aStarts = a.normName.startsWith(normalizedQuery)
    const bStarts = b.normName.startsWith(normalizedQuery)

    if (aStarts && !bStarts)
      return -1
    if (!aStarts && bStarts)
      return 1

    return a.normName.localeCompare(b.normName)
  })

  return filtered.map(item => item.original)
}
